import request from '@/utils/request'

export function fetchAgentAccountList (query) {
  return request({
    url: '/card/api/agent_account/index',
    method: 'get',
    params: query
  })
}

export function fetchAgentAccount (id) {
  return request({
    url: '/card/api/agent_account/view',
    method: 'get',
    params: { id }
  })
}

export function createAgentAccount (data) {
  return request({
    url: '/card/api/agent_account/insert',
    method: 'post',
    data
  })
}

export function updateAgentAccount (data) {
  return request({
    url: '/card/api/agent_account/update',
    method: 'post',
    data
  })
}

export function deleteAgentAccount (id) {
  return request({
    url: '/card/api/agent_account/delete',
    method: 'post',
    params: { id }
  })
}

export function info () {
  return request({
    url: '/card/api/agent_account/info',
    method: 'get',
    params: {}
  })
}

export function bindRecv (data) {
  return request({
    url: '/card/api/agent_account/bindRecv',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/card/api/agent-account.js